<template>
  <div class="feedbackList">
    <m-loading :loading="homeLoading" />
    <img class="feedbackList_img" src="../../assets/images/mine/bg.png" alt="">
    <van-list v-if="newsList.length>0" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoadfeedback">
      <div v-slidein class="news-item" v-for="(item, i) in newsList" :key="i" @click="toNewsDetail(item)">
        <div class="overallBetween item-top">
          <div>{{item.addTime}}</div>
          <div class="overallCenter" :class="item.typeId==1?'Selected':''">{{item.typeId==1?'已回复':'未回复'}}</div>
        </div>
        <div class="item-eedback">
          <div class="AlignTop">反馈内容：</div>
          <div class="AlignTop">{{item.content}}</div>
        </div>
        <div class="item-reply" v-if="item.typeId==1">
          {{item.reply}}
        </div>
      </div>
    </van-list>
    <div class="nullData" v-else-if="!homeLoading">
      <img class="nullData_img" src="../../assets/images/mine/quesheng.png" alt="">
      <div class="nullData_tip"></div>
    </div>
    <img v-draggable class="wentifankui-img" @click="getfeedback" src="../../assets/images/mine/wentifankui.png"/>
  </div>
</template>
<script>
import { getfeedbackList } from "@/utils/api/user";
export default {
  components: {
  },
  data() {
    return {
      homeLoading:true,
      loading:false,
      finished:false,
      newsList:[],
      page:0,
    }
  },
  async mounted() {
    this.onLoadfeedback()
  },
  methods: {
    //
    onLoadfeedback() {
      this.loading = true;
      this.page++;
      getfeedbackList({
        pageNo: this.page,
        pageSize: 10
      }).then((res) => {
        if (res.success) {
          this.newsList.push(...res.data.records);
          if (this.page * 10 >= res.data.total) this.finished = true;
          this.loading = false;
        } else {
          this.loading = false;
          this.finished = true;
        }
        this.homeLoading = false
      });
    },
    getfeedback(){
      this.$router.push("/mine/feedback");
    }
  }
}
</script>
<style lang="scss" scoped>
.feedbackList{
  position: absolute;
  min-height: 100vh;
  background-color:#F9F9FA;
  width: 375px;
  padding: 0 15px;
  .feedbackList_img{
    position: fixed;
    top: 0px;
    left: 0px;
    height: 339px;
    width: 375px;
  }
  .nullData{
    position: relative;
    margin-top: 30%;
    .nullData_img{
      width: 146px;
      height: 120px;
    }
    .nullData_tip{
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #404046;
      line-height: 18px;
    }
  }
  .news-item {
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    padding:0 15px;
    margin-bottom: 15px;
    padding-bottom:1px;
    .item-top{
      height: 43px;
      width: 315px;
      border-bottom: 1px solid #F0F0F0;
      div:first-child{
        font-size: 12px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      div:last-child{
        width: 53px;
        height: 22px;
        background: rgba(255,114,70,0.1);
        border-radius: 25px 25px 25px 25px;
        font-size: 12px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        color: #FF7246;
      }
      .Selected{
        background: rgba(49,208,118,0.1);
        color: #31D076;
      }
    }
    .item-eedback{
      margin-top: 17px;
      margin-bottom: 20px;
      div:first-child{
        width: 75px;
        min-width: 75px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #999999;
      }
      div:last-child{
        width: 230px;
        max-width: 240px;
        font-size: 15px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        color: #222222;
      }
    }
  }
  .van-list{
    position: relative;
    padding-top: 10px;
  }
  .wentifankui-img{
    position: fixed;
    right: 0px;
    top: 400px;
    width: 101px;
    height: 47px;
    z-index: 1000;
  }
  .item-reply{
    width: 315px;
    max-width: 315px;
    padding: 13px 9px;
    margin-bottom: 14px;
    background: #F9F9FA;
    border-radius: 8px 8px 8px 8px;
    font-size: 15px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    color: #666666;
    text-align: left;
  }
}
</style>